import { JobStatus } from '@/api/generatedApi';

export const isReportInProgress = (status: JobStatus | undefined): boolean =>
  status === JobStatus.PENDING || status === JobStatus.RUNNING;
